import {ISettings, SettingsMap} from '@fantasmagames/slot/src/common/settings/_interfaces/ISettings';
import {injectable} from 'inversify';

@injectable()
export class Settings implements ISettings {
	public static readonly IS_QUICKSPIN_AVAILABLE: string = 'Settings::IsQuickSpinAvailable';
	public static readonly QUICKSPIN: string = 'Settings::QuickSpin';
	public static readonly SOUNDS_ON: string = 'Settings::SoundsOn';
	public static readonly MUSIC_ON: string = 'Settings::MusicOn';

	protected _settings: SettingsMap = {};

	constructor() {
		this.add(Settings.IS_QUICKSPIN_AVAILABLE, true);
		this.add(Settings.QUICKSPIN, false);
		this.add(Settings.SOUNDS_ON, true);
		this.add(Settings.MUSIC_ON, true);
	}

	public has(name: string): boolean {
		return this._settings.hasOwnProperty(name);
	}

	public add(name: string, value: any): void {
		this._settings[name] = value;
	}

	public remove(name: string): void {
		delete this._settings[name];
	}

	public get(name: string): any {
		return this._settings[name];
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/common/settings/Settings.ts